// extracted by mini-css-extract-plugin
export default {"NameFolder":"DeleteFolderModal_NameFolder__ai08+"};